module.exports = __webpack_public_path__ + "assets/images/cockpit/hover/btn_contact-hover_ru.png";